import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { KeycloakAuthGuard, KeycloakService } from "keycloak-angular";
import { SupplierDetails } from "src/app/components/supplier/models/SupplierDetails";
import { SupplierService } from "src/app/components/supplier/services/supplier.service";
import { UserService } from "src/app/public/onboarding/services/user.service";
import {environment} from "../../../environments/environment";

@Injectable({
    providedIn: 'root',
})

export class SupplierAuthGuard extends KeycloakAuthGuard {

    constructor(
        protected override router: Router,
        private supplierService: SupplierService,
        protected userService: UserService,
        protected keycloakService: KeycloakService
    ) {
        super(router, keycloakService);
    }


    isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        return new Promise((resolve, reject) => {
            if (!this.authenticated) {
                this.userService.clearCachedUserProfile();
                this.keycloakService.login({ redirectUri: environment.feUrl });
                return resolve(true);
            }
            this.supplierService.getSupplierDetails().subscribe(
                (supplier: SupplierDetails) => {
                    if (supplier.validatedAndAdminRoleAssigned === false) {
                        resolve(false);
                    } else {
                        resolve(true);
                    }
                }
            );
        });
    }

}
